<teleport to="body">
<div v-if="is_open" class="modal show d-block settings-modal-backdrop" tabindex="-1" role="dialog" aria-modal="true" @click.self="close_modal">
    <div v-if="load_error || save_error || save_success" class="toast-container position-fixed bottom-0 end-0 p-3" aria-live="polite" aria-atomic="true">
        <div v-if="load_error" class="toast show align-items-center text-dark border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ load_error }}</div>
                <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_load_error"></button>
            </div>
        </div>

        <div v-if="save_error" class="toast show align-items-center text-dark border-0 shadow-lg auth-toast auth-toast-error" role="alert">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-exclamation-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ save_error }}</div>
                <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss error message" @click="clear_save_error"></button>
            </div>
        </div>

        <div v-if="save_success" class="toast show align-items-center text-dark border-0 shadow-lg auth-toast auth-toast-success" role="status">
            <div class="d-flex align-items-center gap-3 p-3">
                <span class="auth-toast-icon rounded-circle d-inline-flex align-items-center justify-content-center flex-shrink-0" aria-hidden="true">
                    <i class="bi bi-check2-circle"></i>
                </span>
                <div class="toast-body p-0 fw-semibold lh-sm">{{ save_success }}</div>
                <button type="button" class="btn-close ms-auto flex-shrink-0" aria-label="Dismiss success message" @click="clear_save_success"></button>
            </div>
        </div>
    </div>

    <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable modal-xl settings-modal-dialog tariff-rates-modal-dialog" role="document">
    <div class="modal-content glass-card rounded-4 p-0 border border-dark overflow-hidden d-flex flex-column">
        <div class="modal-header align-items-start">
            <div>
                <h5 class="text-xs fw-bold mb-1">{{ modal_title }}</h5>
                <p class="text-muted text-xs fw-semibold mb-0">{{ modal_subtitle }}</p>
            </div>

            <button
                type="button"
                class="btn btn-sm btn-outline-dark rounded-circle"
                @click="close_modal"
                aria-label="Close tariff rates modal"
            >
                <i class="bi bi-x-lg"></i>
            </button>
        </div>

        <div v-if="is_loading" class="modal-body">
            <div class="border rounded-4 p-4 text-muted">
                <div class="d-flex align-items-center gap-3">
                    <div class="spinner-border spinner-border-sm text-secondary" role="status" aria-hidden="true"></div>
                    <div>
                        <p class="fw-semibold mb-1">Loading tariff rates</p>
                        <p class="text-muted text-xs mb-0">We are fetching the detailed rates linked to this tariff book.</p>
                    </div>
                </div>
            </div>
        </div>

        <div v-else class="modal-body">
            <TariffRatesEditTab
                :rate_rows="rate_rows"
                :context="context"
                :tariff_book="tariff_book"
                :is_saving="is_saving"
                :supports_rate_updates="supports_rate_updates"
                :format_date="format_date"
                :get_metric_rows="get_metric_rows"
                @update-effective="update_rate_effective_field"
                @update-metric="update_metric_value"
            />
        </div>

        <div class="modal-footer">
            <button type="button" class="btn btn-outline-dark btn-sm rounded-3 d-inline-flex align-items-center px-3 shadow-sm" @click="close_modal">
                <span class="text-xs">Close</span>
            </button>

            <button
                type="button"
                class="btn btn-primary btn-sm rounded-3 d-inline-flex align-items-center px-3 shadow-sm"
                :disabled="is_saving || !supports_rate_updates || !rate_rows.length"
                @click="save_rate(rate_rows[0])"
            >
                <span class="text-xs">{{ supports_rate_updates ? (is_saving ? "Saving..." : "Save changes") : "Save unavailable" }}</span>
            </button>
        </div>
    </div>
    </div>
</div>
</teleport>
